var FuzzyReaction = require('../bootstrap').FuzzyReaction;
var AppDispatcher = FuzzyReaction.Dispatcher;
var AppActionConstants = require('../constants/AppActionConstants');
var assign = require('object-assign');
var ModelStore = FuzzyReaction.Stores.ModelStore;

var ActionTypes = AppActionConstants.ActionTypes.casts;
var CmsActionTypes = FuzzyReaction.Constants.ActionTypes.cms.requests;

/**
 * Data stores
 * @type {Array}
 * @private
 */
// Store for cast and related data
var _resourceListData = [];
var _instructors = [];
var _storedCast = {};
var _resourceData = {};
var _uploadProgress = {};
var _sampleCast = {};

/**
 * User store logic
 *
 * @type {*|exports}
 */
var CastStore = assign({}, ModelStore, {
    getResourceListData: function () {
        return _resourceListData;
    },

    getResource: function () {
        return _resourceData;
    },

    getResourceById: function (id) {
        // http://stackoverflow.com/questions/12553274/getting-index-of-an-arrays-element-based-on-its-properties
        var index = _resourceListData.map(function (item) {
            return item.id;
        }).indexOf(Number(id));

        return _resourceListData[index];
    },

    getInstructors: function () {
        return _instructors;
    },

    getStoredCast: function () {
        return _storedCast;
    },

    getUploadProgress: function () {
        return _uploadProgress;
    },

    getCurrentSampleCast: function () {
        return _sampleCast;
    }
});

/**
 * Event Listeners
 */
CastStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.type) {
        case 'CASTS_RECEIVED':
            _resourceData = action.data;

            // Don't need
            delete _resourceData.transcoding_job;
            delete _resourceData.recording_stream;
            delete _resourceData.track_stream;

            CastStore.emitChange();
            break;
        case 'CASTS_UPDATED':
            _resourceData = action.data;

            // Don't need
            delete _resourceData.transcoding_job;
            delete _resourceData.recording_stream;
            delete _resourceData.track_stream;

            CastStore.emitChange();
            break;
        case 'CASTS_CREATED':
            _resourceData = action.data;

            // Don't need
            delete _resourceData.transcoding_job;
            delete _resourceData.recording_stream;
            delete _resourceData.track_stream;

            CastStore.emitChange();
            break;
        case 'CASTS_LISTED':
            _resourceListData = action.data;

            CastStore.emitChange();
            break;
        case 'INSTRUCTORS_LISTED':
            _instructors = action.data;

            CastStore.emitChange();
            break;
        case ActionTypes.STORE_CAST:
            _storedCast = action.data;

            //CastStore.emitChange(); @todo needed?
            break;
        case ActionTypes.CLEAR_STORED_CAST:
            _resourceData = {};
            break;
        case CmsActionTypes.UPLOAD_PROGRESS:
            _uploadProgress = action.data;

            CastStore.emitChange();
            break;
    }
});

module.exports = CastStore;
